// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'folder-hierarchy-solid';

export const Component = () => (
  <path d='M9.406 2H1.437a.93.93 0 0 0-.656.28C.594 2.513.5 2.745.5 2.978v19.09c0 .233.094.466.281.652a.93.93 0 0 0 .656.28h22.126a.93.93 0 0 0 .656-.28.917.917 0 0 0 .281-.651V5.819a.917.917 0 0 0-.281-.652.93.93 0 0 0-.656-.28H11.047l-.75-2.235C10.203 2.232 9.922 2 9.406 2Zm7.413 10.057-4.241 4.768-4.4-4.768h8.641Z' />
);

export const viewBox = '0 0 25 25';
